import React, { useEffect, useState } from "react";
import {Box, Table, TableBody, TableCell,Chip, TableContainer, TableHead, TableRow, Paper, Checkbox, IconButton, 
    Tooltip, Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, TablePagination, TextField,FormControlLabel,
    Autocomplete,} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from '@mui/icons-material/Edit';
import axios from "axios";
import CancelSharpIcon from '@mui/icons-material/CancelSharp';
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp';
import { useNavigate } from "react-router-dom";
import './PendingEvents.css';

const PendingPost = () => {
  const [pendingEvents, setPendingEvents] = useState([]);
  const [selected, setSelected] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [value, setValue] = useState(0);
  const [pendingImageFile, setPendingImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedPostingTypes, setSelectedPostingTypes] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [postingTypes, setPostingTypes] = useState([]);
  const sortOptions = [
    // { label: "Recently Added", value: "recent" },
    { label: "New to Old", value: "newToOld" },
    { label: "Old to New", value: "oldToNew" },
  ];
  const [categories, setCategories] = useState([]);
  const [hostOrganisations, setHostOrganisations] = useState([]);
  const [searchHost, setSearchHost] = useState("");
  const [searchEvent, setSearchEvent] = useState("");
  const [reason,setReason] = useState("");
  useEffect(() => {
    const fetchPendingEvents = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/pendingevents`);
        setPendingEvents(response.data);

        const allCategories = new Set();
        const allPostingTypes = new Set();
        const allHosts = new Set();

        response.data.forEach((event) => {
          event.categories?.forEach((c) => allCategories.add(c));
          event.postingTypes?.forEach((p) => allPostingTypes.add(p));
          if (event.hostOrganisation) allHosts.add(event.hostOrganisation);
        });

        setCategories(Array.from(allCategories));
        setPostingTypes(Array.from(allPostingTypes));
        setHostOrganisations(Array.from(allHosts));
      } catch (error) {
        console.error("Error fetching pending events:", error);
      }
    };

    fetchPendingEvents();
  }, []);
  const [enumOptions, setEnumOptions] = useState({
    postingTypes: [],
    categories: [],
    costs: [],
    modes: [],
  });

  async function getUsernamefromCookie() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, { withCredentials: true }); 
      if (response.data.username ) {
        setUsername(response.data.username);
        setIsLoggedIn(true);
        setUserType(response.data.user);
      } else {
        setIsLoggedIn(false);
        navigate('/login'); 
      }
    } catch (error) {
      console.error('Error fetching login status:', error);
      navigate('/login'); 
    }
  }

  useEffect(() => {
    getUsernamefromCookie();
  }, []);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userType, setUserType] = useState('');
  const [userName, setUsername] = useState('');
  const [formData, setFormData] = useState({
      hostOrganisation: '',
      eventName: '',
      postStartDate: '',
      postEndDate: '',
      applicationDeadline: '',
      description: '',
      postingTypes: [],
      categories: [],
      cost: '',
      location: '',
      targetGroup: '',
      country: '',
      mode: '',
      hostURL: '',
      eventPosting: '',
      onlineSessionLink: '',
      postedBy: '',
      createdBy: userName,
      yearlyImportant: false,
      attachments:[]
    });

  useEffect(() => {
  const fetchEnumOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/categoryValues`);
      setEnumOptions(response.data);
    } catch (err) {
      console.error('Error fetching enum options:', err);
    }
  };
  fetchEnumOptions();
}, []);


  const navigate = useNavigate();
  const handleSelectAllClick = (event) => {
    setSelected(event.target.checked ? pendingEvents.map((event) => event._id) : []);
  };

  const handleRowClick = (id) => {
    setSelected((prevSelected) =>
      prevSelected.includes(id) ? prevSelected.filter((item) => item !== id) : [...prevSelected, id]
    );
  };

 const handleApprove = async (id) => {
  try {
    await axios.put(`${API_BASE_URL}/api/approveevent/${id}`, {
      // approvedBy: "Admin",
      approvedBy:userName
    }, {
      headers: {
        "Content-Type": "application/json"
      }
    });

    setPendingEvents((prev) => prev.filter((event) => event._id !== id));
  } catch (error) {
    console.error("Error approving event:", error);
  }
};

// const handleReject = async (id) => {
//    try {
//     await axios.put(`${API_BASE_URL}/api/rejectevent/${id}`, {
//       // approvedBy: "Admin",
//       approvedBy:userName
//     }, {
//       headers: {
//         "Content-Type": "application/json"
//       }
//     });

//     setPendingEvents((prev) => prev.filter((event) => event._id !== id));
//   } catch (error) {
//     console.error("Error approving event:", error);
//   }
// };
const handleReject = async (id) => {
  try {
    await axios.put(`${API_BASE_URL}/api/rejectevent/${id}`, {
      approvedBy: userName
    }, {
      headers: {
        "Content-Type": "application/json"
      }
    });

    setPendingEvents((prev) => prev.filter((event) => event._id !== id));
  } catch (error) {
    console.error("Error rejecting event:", error);
  }
};

const [openDialogreason, setOpenDialogreason] = useState(false);
const [currentEventId, setCurrentEventId] = useState(null);

const handleOpenDialogReason = (id) => {
  setCurrentEventId(id);
  setOpenDialogreason(true);
};

const handleCloseDialogReason = () => {
  setOpenDialogreason(false);
  setReason("");
};

const handleReview = async () => {
  try {
    await axios.put(`${API_BASE_URL}/api/reviewevent/${currentEventId}`, {
      approvedBy: userName,
      rejectionReason: reason
    });

    setPendingEvents((prev) => prev.filter((event) => event._id !== currentEventId));
    handleCloseDialogReason();
  } catch (error) {
    console.error("Error reviewing event:", error);
  }
};

const handleOpenDialog = (event) => {
  setSelectedEvent(event);
  setFormData(event); 
  setOpenDialog(true);
};


  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedEvent(null);
    setPendingImageFile(null);
    setPendingDocs([]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedEvent((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: [...value],
    }));
  };

  const handleFormChange = (e) => {
  const { name, value, type, checked } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/approveevent/${selectedEvent._id}`,
      formData,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    handleCloseDialog();
  } catch (error) {
    console.error('Error submitting event:', error);
  }
};

  const [pendingDocs, setPendingDocs] = useState([]);

  const handleSave = async () => {
    try {
      let imageUrl = formData.eventImage;
      let pdfUrls = formData.attachments || [];

      if (pendingImageFile) {
        const imgData = new FormData();
        imgData.append("image", pendingImageFile);
        imgData.append('eventName', formData.eventName);
        const res = await axios.post(`${API_BASE_URL}/upload-image`, imgData);
        imageUrl = res.data.imageUrl;
      }

      if (pendingDocs.length > 0) {
        pdfUrls = [];
        for (const file of pendingDocs) {
          const pdfData = new FormData();
          pdfData.append("file", file);
          pdfData.append('eventName', formData.eventName);
          const res = await axios.post(`${API_BASE_URL}/upload-pdf`, pdfData);
          if (res.data.pdfUrl) pdfUrls.push(res.data.pdfUrl);
        }
      }

      const payload = { ...formData, eventImage: imageUrl, attachments: pdfUrls };
      await axios.put(`${API_BASE_URL}/api/events/${selectedEvent._id}`, payload);
    setFormData((prev) => ({ ...prev, eventImage: imageUrl, attachments: pdfUrls }));

      handleCloseDialog();
      setPendingImageFile(null);
      setPendingDocs([]);
      const response = await axios.get(`${API_BASE_URL}/api/pendingevents`);
      setPendingEvents(response.data);
    
    } catch (err) {
      console.error("Submission failed:", err);
    }
  };

  const applyFilters = async () => {
    setLoading(true);
    try {
      const payload = {
         sortBy:sortBy,
        categories: selectedCategories,
        postingTypes: selectedPostingTypes,
        hostOrganisation: searchHost.trim() || null,
        eventName: searchEvent.trim() || null,
      };

      const response = await axios.post(`${API_BASE_URL}/api/pendingeventsFilter`, payload);
      setPendingEvents(response.data);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false);
    }
  };

  const clearSelection = async () => {
  setSelectedCategories([]);
  // setSelectedPostingTypes([]);
  setSearchHost("");
  setSearchEvent("");
  setSortBy("")
  try {
    const response = await axios.get(`${API_BASE_URL}/api/pendingevents`);
    setPendingEvents(response.data);
  } catch (error) {
    console.error("Error resetting pending events:", error);
  }
};

  return (
    <Box sx={{ width: '100%', padding: 0, margin: 0 }}>
  {isLoggedIn && userName.length > 0 ? (
    <>
     <div className="form-container-1">
  <Box sx={{ display: "flex",  gap: 2, flexWrap: "wrap",   justifyContent: "center", alignItems: "center",}}  >      
      <Autocomplete
          multiple
          options={categories}
          value={selectedCategories}
          onChange={(e, val) => setSelectedCategories(val)}
          renderInput={(params) => <TextField {...params} label="Tag" />}
          sx={{ width: 250 }}
        />

        {/* <Autocomplete
          multiple
          options={postingTypes}
          value={selectedPostingTypes}
          onChange={(e, val) => setSelectedPostingTypes(val)}
          renderInput={(params) => <TextField {...params} label="Posting Type" />}
          sx={{ width: 250 }}
        /> */}

        <Autocomplete
          freeSolo
          options={hostOrganisations}
          inputValue={searchHost}
          onInputChange={(e, val) => setSearchHost(val)}
          renderInput={(params) => <TextField {...params} label="Host Organization" />}
          sx={{ width: 250 }}
        />

        <Autocomplete
          freeSolo
          options={pendingEvents.map((e) => e.eventName).filter(Boolean)}
          inputValue={searchEvent}
          onInputChange={(e, val) => setSearchEvent(val)}
          renderInput={(params) => <TextField {...params} label="Event Name" />}
          sx={{ width: 250 }}
        />
          <Autocomplete
                  disablePortal
                  id="SortBy"
                  options={sortOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    sortOptions.find((opt) => opt.value === sortBy) || null
                  }
                  onChange={(event, newValue) =>
                    setSortBy(newValue ? newValue.value : "")
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Sort By" variant="outlined" />
                  )}
                  sx={{ width: 250 }}
                />
      </Box>
              <Box
                sx={{
                  padding: 4,
                  display: "flex",
                  gap: 2,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button variant="contained" color="primary" onClick={applyFilters}>
                  Apply Filters
                </Button>
                <Button variant="outlined" onClick={clearSelection}>
                  Clear Selection
                </Button>
              </Box>
      </div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={selected.length > 0 && selected.length < pendingEvents.length}
                  checked={selected.length === pendingEvents.length}
                  onChange={handleSelectAllClick}
                />
              </TableCell>
              <TableCell> Event</TableCell>
              <TableCell align="center" colSpan={4}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pendingEvents
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((event) => (
                <TableRow key={event._id} hover>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selected.includes(event._id)}
                      onClick={() => handleRowClick(event._id)}
                    />
                  </TableCell>
                  <TableCell>
              <Box  className="event-card-postApproval">
                {/* <img src={event.eventImage} alt="Event" className="category-image"  onClick={() => navigate(`/event/${event._id}`)}/> */}

      <Box className="event-details">
        <Typography variant="h6" className="event-title" onClick={() => handleOpenDialog(event)}>
          {event.eventName}
        </Typography>
        <Typography variant="body2" className="event-category">
          <strong>Tag:</strong>{" "}
          {Array.isArray(event.categories)
            ? event.categories.join(", ")
            : "No Category"}
        </Typography>

        <Typography variant="body2" className="event-description">
          {event.description.length > 100
            ? `${event.description.substring(0, 100)}...`
            : event.description}
        </Typography>
      </Box>
      </Box>
      </TableCell>
                  <TableCell>
                    <Tooltip title="Approve">
                      <IconButton color="success" onClick={() => handleApprove(event._id)}>
                        <CheckCircleIcon />
                      </IconButton>
                    </Tooltip>
                    </TableCell>
                    <TableCell>
                    <Tooltip title="Reject">
                      <IconButton color="error" onClick={() => handleReject(event._id)}>
                        <CancelIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                   <TableCell>
                 <Tooltip title="Review">
                <Button color="error" onClick={() => handleOpenDialogReason(event._id)}>
                  Review Again
                </Button>
              </Tooltip>

                    </TableCell>
                  <TableCell>
                    <Tooltip title="Edit">
                      <IconButton onClick={() => handleOpenDialog(event)}>
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={pendingEvents.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) =>
          setRowsPerPage(parseInt(event.target.value, 10))
        }
      />
       {/* {selectedEvent &&( */}
        <Dialog open={openDialogreason} onClose={handleCloseDialogReason}>
        <DialogTitle>Enter Rejection Reason</DialogTitle>
        <DialogContent>
           <Box sx={{  width:'100%', minHeight:170 }}>
            <h1></h1>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Rejection Reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogReason}>Cancel</Button>
          <Button color="error" onClick={handleReview}>Review Again</Button>
        </DialogActions>
      </Dialog>
        {/* )} */}
      {selectedEvent && (
        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>Edit {formData.eventName} </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {pendingImageFile ? (
                <img
                  src={URL.createObjectURL(pendingImageFile)}
                  alt="Preview"
                  className="category-image"
                  style={{ width: "40%", maxWidth: "100%", alignSelf: "center" }}
                />
              ) : (
                <img
                  src={formData.eventImage}
                  alt="Existing"
                  className="category-image"
                  style={{ width: "40%", maxWidth: "100%", alignSelf: "center" }}
                />
              )}

              <Button variant="outlined" component="label" style={{ alignSelf: "center" }}>
                Replace Image
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={(e) => setPendingImageFile(e.target.files[0])}
                />
              </Button>

              <Typography variant="subtitle1" className="meta-label">Flyer</Typography>
              {pendingDocs.length > 0 ? (
                pendingDocs.map((file, index) => (
                  <Box key={index}>
                    <Typography>{file.name}</Typography>
                  </Box>
                ))
              ) : (
                Array.isArray(formData.attachments) &&
                formData.attachments.map((url, index) => (
                  <Box key={index}>
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {formData.eventName} PDF {index + 1}
                    </a>
                  </Box>
                ))
              )}

              <Button variant="outlined" component="label">
                Replace PDFs
                <input
                  type="file"
                  hidden
                  multiple
                  accept="application/pdf"
                  onChange={(e) => setPendingDocs(Array.from(e.target.files))}
                />
              </Button>

            <TextField
              fullWidth
              name="hostOrganisation"
              label="Host Organization"
              value={formData.hostOrganisation}
              onChange={handleFormChange}
            />
            <TextField
              fullWidth
              name="eventName"
              label="Event Name"
              value={formData.eventName}
              onChange={handleFormChange}
            />
            <TextField
              fullWidth
              name="postStartDate"
              type="date"
              label="Post Start Date"
              InputLabelProps={{ shrink: true }}
              value={formData.postStartDate?.slice(0, 10) || ""}
              onChange={handleFormChange}
            />
            <TextField
              fullWidth
              name="postEndDate"
              type="date"
              label="Post End Date"
              InputLabelProps={{ shrink: true }}
              value={formData.postEndDate?.slice(0, 10) || ""}
              onChange={handleFormChange}
            />
            <TextField
              fullWidth
              name="applicationDeadline"
              type="date"
              label="Application Deadline"
              InputLabelProps={{ shrink: true }}
              value={formData.applicationDeadline?.slice(0, 10) || ""}
              onChange={handleFormChange}
            />
            <TextField
              fullWidth
              name="description"
              label="Description"
              multiline
              rows={3}
              value={formData.description}
              onChange={handleFormChange}
            />

            <Autocomplete
              multiple
              options={enumOptions.categories}
              getOptionLabel={(option) => option || ''}
              value={formData.categories}
              onChange={(event, newValue) =>
                setFormData((prev) => ({ ...prev, categories: newValue }))
              }
              renderInput={(params) => <TextField {...params} label="Categories" />}
            />

            {/* <Autocomplete
              multiple
              options={enumOptions.postingTypes}
              getOptionLabel={(option) => option || ''}
              value={formData.postingTypes}
              onChange={(event, newValue) =>
                setFormData((prev) => ({ ...prev, postingTypes: newValue }))
              }
              renderInput={(params) => <TextField {...params} label="Posting Types" />}
            /> */}

            <Autocomplete
              options={enumOptions.costs}
              getOptionLabel={(option) => option || ''}
              value={formData.cost}
              onChange={(event, newValue) =>
                setFormData((prev) => ({ ...prev, cost: newValue }))
              }
              renderInput={(params) => <TextField {...params} label="Cost" />}
            />

            <Autocomplete
              options={enumOptions.modes}
              getOptionLabel={(option) => option || ''}
              value={formData.mode}
              onChange={(event, newValue) =>
                setFormData((prev) => ({ ...prev, mode: newValue }))
              }
              renderInput={(params) => <TextField {...params} label="Mode" />}
            />

            <TextField
              fullWidth
              name="location"
              label="Location"
              value={formData.location}
              onChange={handleFormChange}
            />
            <TextField
              fullWidth
              name="targetGroup"
              label="Target Group"
              value={formData.targetGroup}
              onChange={handleFormChange}
            />
            <TextField
              fullWidth
              name="country"
              label="Country"
              value={formData.country}
              onChange={handleFormChange}
            />
             {/* <TextField
              fullWidth
              name="country"
              label="Country"
              value={formData.eventImage}
              onChange={handleFormChange}
            /> */}
          
            <TextField
              fullWidth
              name="hostURL"
              label="URL"
              value={formData.hostURL}
              onChange={handleFormChange}
            />
            {/* <TextField
              fullWidth
              name="eventPosting"
              label="Event Posting"
              value={formData.eventPosting}
              onChange={handleFormChange}
            /> */}
            <TextField
              fullWidth
              name="onlineSessionLink"
              label="Online Meeting Link"
              value={formData.onlineSessionLink}
              onChange={handleFormChange}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="yearlyImportant"
                  checked={formData.yearlyImportant}
                  onChange={handleFormChange}
                />
              }
              label="Recurring event"
            />

       

          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
             Save 
          </Button>
          <Button onClick={handleSubmit} color="primary">
             Approve
          </Button>
        </DialogActions>
      </Dialog>
      

      )}

      {selected.length > 0 && (
        <Box
          sx={{
            padding: 2,
            display: 'flex',
            gap: 2,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => selected.forEach(handleApprove)}
          >
            Approve Selected
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => selected.forEach(handleReject)}
          >
            Reject Selected
          </Button>
        </Box>
      )}
    </>
  ) : (
    <Typography variant="h6" textAlign="center">
      
    </Typography>
  )}
</Box>

  );
};

export default PendingPost;
